import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import {
  BLACKLIST_PHONES_URL,
  getBlacklistPhoneByRoomUrl,
  deleteBlacklistPhoneUrl,
} from "./api-url.constants";
import { BlacklistPhoneDTO, BlacklistPhoneByRoomDTO } from "./dtos";

export const getBlacklistPhones = async (): Promise<BlacklistPhoneDTO[]> => {
  const response = await typedFetch(BLACKLIST_PHONES_URL);
  const data = await response.json();
  return data.data;
};

export const getBlacklistPhonesByRoom = async (
  roomId: string
): Promise<BlacklistPhoneByRoomDTO[]> => {
  const response = await typedFetch(getBlacklistPhoneByRoomUrl(roomId));
  const data = await response.json();
  return data.data;
};

export const deleteBlacklistPhone = async (phone: string, roomId: string): Promise<void> => {
  const result = await typedFetch(deleteBlacklistPhoneUrl(phone, roomId), {
    method: API_METHODS.DELETE,
  });

  if (!result.ok) {
    throw new Error("Failed to delete blacklist phone");
  }
};
